var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTag = function SvgTag(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9999 18.0001L10.0189 18.0001C8.67657 18.0001 8.00542 18.0001 7.38772 17.7934C7.21098 17.7343 7.03859 17.6629 6.87181 17.5797C6.28891 17.2891 5.81434 16.8145 4.86518 15.8653C3.22943 14.2296 2.41156 13.4117 2.27179 12.4179C2.23281 12.1407 2.23281 11.8594 2.27179 11.5823C2.41156 10.5884 3.22943 9.77054 4.86518 8.13479L4.86519 8.13478C5.81434 7.18564 6.28891 6.71106 6.87181 6.42041C7.03859 6.33724 7.21098 6.26583 7.38772 6.20671C8.00542 6.00006 8.67657 6.00006 10.0189 6.00006H14.9999C17.8283 6.00006 19.2426 6.00006 20.1212 6.87874C20.9999 7.75742 20.9999 9.17163 20.9999 12.0001C20.9999 14.8285 20.9999 16.2427 20.1212 17.1214C19.2426 18.0001 17.8283 18.0001 14.9999 18.0001ZM9.99991 14.0001C11.1045 14.0001 11.9999 13.1046 11.9999 12.0001C11.9999 10.8955 11.1045 10.0001 9.99991 10.0001C8.89534 10.0001 7.99991 10.8955 7.99991 12.0001C7.99991 13.1046 8.89534 14.0001 9.99991 14.0001Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Tag.20a8bfee2746efcdb1d26913420459d5.svg";